import { Duration } from 'luxon';

/**
 * Format the total duration with the format "h'h' m'm'"
 *
 * @param seconds - The total duration of the flight in seconds
 * @returns The formatted duration string
 */
export const formatTotalDuration = (seconds: number): string => {
  const duration = Duration.fromMillis(seconds * 1000);
  const hours = Math.floor(duration.as('hours'));
  const minutes = Math.floor(duration.as('minutes') % 60);

  if (hours === 0) {
    return `${minutes}m`;
  }
  return `${hours}h ${minutes}m`;
};
